import styled from 'styled-components';
interface TagProps {
  content?: string;
  prefix?: React.ReactNode;
  suffix?: React.ReactNode;
  cssStyles?: {
    container?: React.CSSProperties;
    content?: React.CSSProperties;
  };
}

export const Tag: React.FC<TagProps> = props => {
  return (
    <Container style={props.cssStyles?.container}>
      {props.prefix && <div>{props.prefix}</div>}
      <Content style={props.cssStyles?.content}>{props.content}</Content>
      {props.suffix && <div>{props.suffix}</div>}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  padding: 6px 12px;
  align-items: center;
  gap: 12px;
  background: ${props => props.theme.colors.background};
  width: fit-content;
  height: 32px;
  border-radius: 4px;
`;

const Content = styled.span`
  font-size: 12px;
  font-weight: 400;
  color: ${props => props.theme.colors.foregroundMuted};
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: 'Nimbus Sans D OT';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;
